import { combineReducers } from 'redux';
import { routerReducer } from '../../common/router';
import comments from './comments';
import { communitiesContext } from '../../common/store/communities-context/communities-context-reducer';
import commentEdit from './edited-comment-id';
import forumData from './forum-data';
import isLoaded from './is-loaded';
import isLoading from './is-loading';
import { location } from '../../common/store/location/location-reducer';
import { maNavigation } from '../../common/store/ma-navigation/ma-navigation-reducer';
import pagination from './pagination';
import posts from './posts';
import search from './search';
import categories from './categories';
import typing from './typing';
import rceTranslations from './rce-translations';
import categoriesManager from './categories-manager';
import { sorting } from './sorting';
import { deepLinkRouting } from './deep-link-routing';
import { translations } from '../../common/store/translations/translations-reducer';
import { basicParams } from '../../common/store/basic-params/basic-params-reducer';
import { experiments } from './experiments';
import { captcha } from './captcha';
import { modalReducer } from '../../common/modals/framework/initialize-store';
import { messageReducer } from '../../common/messages/framework/initialize-store';
import { appSettings } from '../../common/store/app-settings/app-settings-reducer';
import { siteStructure } from '../../common/store/site-structure/site-structure-reducer';
import { uploadedRegistry } from './uploaded-registry';
import { currentUser } from '../../common/store/current-user/current-user-reducer';
import { promisifiedActionsResults } from '../../common/actions-promisifier/store/promisified-actions-reducer';
import { debugState } from '../../common/store/debug-state/debug-state-reducer';
import { instanceValues } from '../../common/store/instance-values/instance-values-reducer';
import { fastFormSubmit } from '../../common/components/fast-form/store/fast-form-reducer';
import { appLoaded } from '../../common/store/app-loaded/app-loaded-reducer';
import { footerPosts } from './footer-posts';

export default combineReducers({
  appLoaded,
  captcha,
  fastFormSubmit,
  debugState,
  promisifiedActionsResults,
  uploadedRegistry,
  experiments,
  translations,
  basicParams,
  ...modalReducer,
  ...routerReducer,
  ...messageReducer,
  appSettings,
  comments,
  communitiesContext,
  commentEdit,
  forumData,
  instanceValues,
  isLoaded,
  isLoading,
  location,
  maNavigation,
  pagination,
  posts,
  search,
  siteStructure,
  categories,
  typing,
  rceTranslations,
  categoriesManager,
  currentUser,
  sorting,
  deepLinkRouting,
  footerPosts,
});
